import { makeStyles } from "@material-ui/core";
import { h4Medium, h5Medium } from "../../../shared/typography";
import { pointer } from "../../../shared/mixins";

export const useStyles = makeStyles(() => ({
  container: {
    height: 312,
    width: 320,
    padding: 48,
    background: "#FFFFFF",
    borderRadius: 32,
  },
  header: {
    marginBottom: 32,
    display: "flex",
    justifyContent: "space-between",
  },
  title: {
    ...h4Medium,
  },
  fieldWrapper: {
    position: "relative",
  },
  fieldWrapperTall: {
    position: "relative",
    height: 80,
  },
  toggleVisibility: {
    ...pointer,
    position: "absolute",
    right: 12,
    top: 10,
    color: "#15222F",
    opacity: 0.8,
  },
  submitButtonWrapper: {
    height: 80,
  },
  submitButton: {
    ...h5Medium,
    ...pointer,
    height: 56,
    width: "100%",
    border: "none",
    textAlign: "center",
    background: "#80BB34",
    borderRadius: 16,
    marginTop: 24,
    color: "#FFFFFF",
    "&:disabled": {
      background: "grey",
      opacity: 0.16,
      cursor: "default",
    },
  },
}));
